import axios from 'axios';
import { resolveRegistryTenantId } from './resolveRegistryTenantId';
import { resolveApiBaseUrl } from './apiOrigin';

/** Shared in-flight refresh so parallel 401s do not rotate the cookie multiple times. */
let refreshPromise = null;

/**
 * Rotates access token using HttpOnly refresh cookie (no body).
 * Uses a standalone client so axios response interceptors do not recurse.
 */
export function postCookieRefresh() {
  if (refreshPromise) {
    return refreshPromise;
  }

  const headers = { 'Content-Type': 'application/json' };
  const tid = resolveRegistryTenantId({ routeOnly: true }) || resolveRegistryTenantId();
  if (tid) headers['X-TenantID'] = tid;

  refreshPromise = axios
    .post(`${resolveApiBaseUrl()}/auth/refresh`, {}, {
      withCredentials: true,
      headers,
    })
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}
